import { Component, Signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UntypedFormControl } from '@angular/forms';

import { Friend } from '@app/home/friends/friends.model';
import { FriendsService } from '@app/home/friends/friends.service';

import { of as observableOf } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { SharedModule } from '@app/shared/shared.module';
import { SearchInputComponent } from '@app/shared/components/search-input/search-input.component';
import { FriendsItemComponent } from '@app/home/friends/friends-item/friends-item.component';

@Component({
  selector: 'slotcom-friends-search',
  templateUrl: './friends-search.component.html',
  styleUrls: ['./friends-search.component.scss'],
  standalone: true,
  imports: [SharedModule, SearchInputComponent, FriendsItemComponent],
})
export class FriendsSearchComponent {
  friendsCtrl = new UntypedFormControl();
  isDropdownOpen = true;

  friends: Signal<Friend[]> = toSignal(
    this.friendsCtrl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term: string) => (term ? this.friendsService.searchFriends(term) : observableOf<Friend[]>([])))
    ),
    { initialValue: [] }
  );

  private readonly friendsService = inject(FriendsService);

  onSearch(value: string): void {
    this.isDropdownOpen = !!value;
    this.friendsCtrl.setValue(value);
  }

  selectFriend(nickName: string): void {
    this.isDropdownOpen = false;
    this.friendsCtrl.setValue(nickName, { emitEvent: false });
  }
}
